<script setup lang="ts">
// 这个组件是为了解决NuxtImg srcset undefined 的问题
import { computed, mergeProps, ref, useAttrs } from 'vue';
import type { ComponentPublicInstance } from 'vue';
import { imgProps } from './const';

defineOptions({ inheritAttrs: false });

const props = defineProps(imgProps);
const attrs = useAttrs();
/** NuxtImg 的 ref 为组件实例（含 $el）；若将来改为原生 img 则为 HTMLImageElement */
const imgRef = ref<ComponentPublicInstance | HTMLImageElement | null>(null);
/** 父级 class/style 等在 attrs 里，必须用 computed，否则 merge 只在首次执行，后续样式变化不会传到 NuxtImg */
const resultProps = computed(() => mergeProps(props, attrs));

function getInnerEl(): HTMLElement | null {
  const v = imgRef.value;
  if (!v) return null;
  return '$el' in v && v.$el ? (v.$el as HTMLElement) : (v as HTMLImageElement);
}

defineExpose({
  get style() {
    return getInnerEl()?.style;
  },
  get offsetWidth() {
    return getInnerEl()?.offsetWidth || 0;
  },
  get offsetHeight() {
    return getInnerEl()?.offsetHeight || 0;
  },
});
export type { NuxtImgWrapProps } from './const';
</script>

<template>
  <NuxtImg v-if="resultProps.src" ref="imgRef" v-bind="resultProps" />
</template>
